import { databaseRef } from "../../../Config/FirebaseDatabase";
import moment from 'moment';

export const FETCH_REPORTS_PENDING = 'FETCH_REPORTS_PENDING';
export const FETCH_REPORTS_FULFILLED = 'FETCH_REPORTS_FULFILLED';
export const FETCH_REPORTS_REJECTED = 'FETCH_REPORTS_REJECTED';

// ACTION GENERATORS
const fetchReportsAction = (deviceUuid) => (dispatch) => {
    dispatch({
        type: FETCH_REPORTS_REJECTED,
    });

    let today = moment().format("YYYY-MM-DD ddd");

    databaseRef.child("Reports/" + today).once('value').then(snapshot => {
        let reports = snapshot.val();
        
        dispatch({
            type: FETCH_REPORTS_FULFILLED,
            payload: reports,
        });

    }).catch(error => {
        console.log(error);
        dispatch({
            type: FETCH_REPORTS_REJECTED,
        });
    })
    
};

// Export Actions
export {
    fetchReportsAction as fetchReports, 
};